<p-toast></p-toast>

<p-dialog
  [(visible)]="visible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  maskStyleClass="dialog-wave-redesign-mask"
  [style]="getDialogStyle()"
  (onShow)="onShowDialog()"
  (visibleChange)="onVisibleChange($event)"
>
  <!-- HEADER WAVE (variante info) -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-credit-card" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ config.tituloHeader || ('forma_pagamento.titulo' | translate) }}</h2>
        <p>
          {{ config.subtituloHeader || ('forma_pagamento.a_pagar' | translate) }}:
          <strong *ngIf="moedaPadrao === 'PYG'">{{ totalAPagar | guaraniFormat }}</strong>
          <strong *ngIf="moedaPadrao !== 'PYG'">
            {{ totalAPagar | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
          </strong>
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">

    <!-- RADIO BUTTONS - Selecao da forma de pagamento -->
    <div class="forma-pagamento-radios">
      <div
        *ngIf="config.formasPermitidas.includes('dinheiro')"
        class="radio-forma-item"
        [class.radio-forma-item--active]="formaPagamentoSelecionada === 'dinheiro'">
        <p-radioButton
          name="formaPagamento"
          value="dinheiro"
          [(ngModel)]="formaPagamentoSelecionada"
          (ngModelChange)="onFormaPagamentoChange($event)"
          inputId="fp-dinheiro">
        </p-radioButton>
        <label for="fp-dinheiro">
          <i class="pi pi-wallet"></i>
          {{ 'forma_pagamento.dinheiro' | translate }}
          (Alt+1)
        </label>
      </div>

      <div
        *ngIf="config.formasPermitidas.includes('conta')"
        class="radio-forma-item"
        [class.radio-forma-item--active]="formaPagamentoSelecionada === 'conta'">
        <p-radioButton
          name="formaPagamento"
          value="conta"
          [(ngModel)]="formaPagamentoSelecionada"
          (ngModelChange)="onFormaPagamentoChange($event)"
          inputId="fp-conta">
        </p-radioButton>
        <label for="fp-conta">
          <i class="pi pi-building"></i>
          {{ 'forma_pagamento.transferencia' | translate }}
          (Alt+2)
        </label>
      </div>

      <div
        *ngIf="config.formasPermitidas.includes('prazo')"
        class="radio-forma-item"
        [class.radio-forma-item--active]="formaPagamentoSelecionada === 'prazo'">
        <p-radioButton
          name="formaPagamento"
          value="prazo"
          [(ngModel)]="formaPagamentoSelecionada"
          (ngModelChange)="onFormaPagamentoChange($event)"
          inputId="fp-prazo">
        </p-radioButton>
        <label for="fp-prazo">
          <i class="pi pi-calendar"></i>
          {{ 'forma_pagamento.a_prazo' | translate }}
          (Alt+3)
        </label>
      </div>

      <div
        *ngIf="config.formasPermitidas.includes('cartao')"
        class="radio-forma-item"
        [class.radio-forma-item--active]="formaPagamentoSelecionada === 'cartao'">
        <p-radioButton
          name="formaPagamento"
          value="cartao"
          [(ngModel)]="formaPagamentoSelecionada"
          (ngModelChange)="onFormaPagamentoChange($event)"
          inputId="fp-cartao">
        </p-radioButton>
        <label for="fp-cartao">
          <i class="pi pi-credit-card"></i>
          {{ 'forma_pagamento.cartao' | translate }}
          (Alt+4)
        </label>
      </div>

      <div
        *ngIf="config.formasPermitidas.includes('qrcode')"
        class="radio-forma-item"
        [class.radio-forma-item--active]="formaPagamentoSelecionada === 'qrcode'">
        <p-radioButton
          name="formaPagamento"
          value="qrcode"
          [(ngModel)]="formaPagamentoSelecionada"
          (ngModelChange)="onFormaPagamentoChange($event)"
          inputId="fp-qrcode">
        </p-radioButton>
        <label for="fp-qrcode">
          <i class="pi pi-qrcode"></i>
          {{ 'forma_pagamento.qrcode' | translate }}
          (Alt+5)
        </label>
      </div>
    </div>

    <!-- ===== DINHEIRO ===== -->
    <div *ngIf="formaPagamentoSelecionada === 'dinheiro'">
      <!-- Cards de moeda delegados ao sub-componente shared (DRY).
           A logica de matriz, gating, troco multi-moeda e digitacao vive
           em app-forma-pagamento-cards. Este dialog continua dono dos totais
           e do header. -->
      <app-forma-pagamento-cards
        #cards
        [moedaPadrao]="moedaPadrao"
        [moedaEmpresa]="moedaEmpresa"
        [cotPYG]="cotPYG"
        [cotBRL]="cotBRL"
        [cotPesoGuarani]="cotPesoGuarani"
        [cotRealGuarani]="cotRealGuarani"
        [totalAPagar]="totalAPagar"
        [(valores)]="valores"
        [prefillMoedaPadrao]="true"
        [mostrarTroco]="true"
        (valoresChange)="onValoresChange($event)"
        (totalConvertidoChange)="onTotalConvertidoChange($event)"
        (trocosChange)="onTrocosChange($event)">
      </app-forma-pagamento-cards>

      <!-- Totais Dinheiro -->
      <div class="totais-section">
        <!-- Linha compacta: Pagado | Vuelto | Total Enviado -->
        <div class="totais-resumo-linha">
          <span class="totais-resumo-item">
            <span class="totais-resumo-label">{{ 'forma_pagamento.pago' | translate }}</span>
            <strong *ngIf="moedaPadrao === 'PYG'">{{ totalPago | guaraniFormat }}</strong>
            <strong *ngIf="moedaPadrao !== 'PYG'">{{ totalPago | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</strong>
          </span>
          <span class="totais-resumo-separador">|</span>
          <span class="totais-resumo-item">
            <span class="totais-resumo-label">{{ 'forma_pagamento.troco' | translate }}</span>
            <strong *ngIf="moedaPadrao === 'PYG'">{{ totalTroco | guaraniFormat }}</strong>
            <strong *ngIf="moedaPadrao !== 'PYG'">{{ totalTroco | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</strong>
          </span>
          <span class="totais-resumo-separador">|</span>
          <span class="totais-resumo-item">
            <span class="totais-resumo-label">{{ 'forma_pagamento.total_enviado' | translate }}</span>
            <strong *ngIf="moedaPadrao === 'PYG'" [ngStyle]="{ color: corTotalEnviadoDinheiro }">{{ totalEnviado | guaraniFormat }}</strong>
            <strong *ngIf="moedaPadrao !== 'PYG'" [ngStyle]="{ color: corTotalEnviadoDinheiro }">{{ totalEnviado | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</strong>
          </span>
        </div>
        <!-- Total a pagar destacado -->
        <div>
          <span>{{ 'forma_pagamento.total_a_pagar' | translate }}</span>
          <strong *ngIf="moedaPadrao === 'PYG'">{{ totalAPagar | guaraniFormat }}</strong>
          <strong *ngIf="moedaPadrao !== 'PYG'">{{ totalAPagar | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</strong>
        </div>
      </div>
    </div>

    <!-- ===== CONTA ===== -->
    <div *ngIf="formaPagamentoSelecionada === 'conta'" class="conta-section">
      <div class="conta-card">
        <div class="conta-card-header">
          <div class="conta-card-icon">
            <i class="pi pi-wallet"></i>
          </div>
          <div class="conta-card-info">
            <span class="conta-card-title">{{ 'forma_pagamento.transferencia' | translate }}</span>
            <span class="conta-card-subtitle">{{ 'forma_pagamento.selecione_conta' | translate }}</span>
          </div>
        </div>
        <div class="conta-card-body">
          <div class="conta-field">
            <label>{{ 'forma_pagamento.conta' | translate }}</label>
            <p-dropdown
              #contaDD
              [options]="contasFiltradas"
              [(ngModel)]="contaSelecionada"
              optionLabel="label"
              [placeholder]="'forma_pagamento.selecione_conta' | translate"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              [appendTo]="'body'"
              panelStyleClass="dropdown-panel-above-modal"
              [style]="{ width: '100%' }">
              <ng-template pTemplate="selectedItem" let-conta>
                <div class="dropdown-conta-item" *ngIf="conta">
                  <img *ngIf="getFlagUrlFromConta(conta)" [src]="getFlagUrlFromConta(conta)" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-conta>
                <div class="dropdown-conta-item">
                  <img *ngIf="getFlagUrlFromConta(conta)" [src]="getFlagUrlFromConta(conta)" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>

          <div class="conta-field">
            <label for="infoTransacao">{{ 'forma_pagamento.informacao_transacao' | translate }}</label>
            <textarea
              id="infoTransacao"
              pInputTextarea
              autoResize="true"
              rows="3"
              [(ngModel)]="informacaoDaTransacao"
              [placeholder]="'forma_pagamento.informacao_transacao_placeholder' | translate"
              style="width: 100%;"></textarea>
          </div>
        </div>
      </div>

      <!-- Totais Conta -->
      <div class="totais-section">
        <div>
          <span>{{ 'forma_pagamento.total_a_pagar' | translate }}</span>
          <strong *ngIf="moedaPadrao === 'PYG'">{{ totalAPagar | guaraniFormat }}</strong>
          <strong *ngIf="moedaPadrao !== 'PYG'">{{ totalAPagar | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</strong>
        </div>
      </div>
    </div>

    <!-- ===== PRAZO ===== -->
    <div *ngIf="formaPagamentoSelecionada === 'prazo'" class="prazo-section">
      <div class="prazo-card">
        <div class="prazo-card-header">
          <div class="prazo-card-icon">
            <i class="pi pi-calendar"></i>
          </div>
          <div class="prazo-card-info">
            <span class="prazo-card-title">{{ 'forma_pagamento.detalhes_parcelas' | translate }}</span>
            <span class="prazo-card-subtitle">{{ numeroParcelas }} {{ numeroParcelas === 1 ? ('forma_pagamento.parcela' | translate) : ('forma_pagamento.parcelas' | translate) }}</span>
          </div>
          <div class="prazo-parcelas-control">
            <button pButton class="p-button-rounded p-button-text prazo-btn-control" icon="pi pi-minus" (click)="diminuirParcela()"></button>
            <input
              #numeroParcelasInput
              id="numeroParcelas"
              type="number"
              pInputText
              [(ngModel)]="numeroParcelas"
              min="1"
              (input)="onNumeroParcelasDigitado()"
              class="prazo-input-parcelas"
            />
            <button pButton class="p-button-rounded p-button-text prazo-btn-control" icon="pi pi-plus" (click)="adicionarParcela()"></button>
          </div>
        </div>
        <div class="prazo-card-body">
          <div class="prazo-table-container">
            <table class="prazo-table">
              <thead>
                <tr>
                  <th style="width: 10%; white-space: nowrap;">{{ 'forma_pagamento.n_parcela' | translate }}</th>
                  <th style="width: 35%;">{{ 'forma_pagamento.valor' | translate }}</th>
                  <th style="width: 55%;">{{ 'forma_pagamento.data_vencimento' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let titulo of titulos; let i = index">
                  <td>
                    <span class="prazo-parcela-num">{{ i + 1 }}</span>
                  </td>
                  <td>
                    <input
                      type="text"
                      pInputText
                      [value]="titulo.valorStr"
                      (input)="onParcelaValorInput(titulo, $event, i)"
                      (blur)="recalcularParcelasSubsequentes(i)"
                      class="prazo-input-valor"
                      inputmode="numeric" />
                  </td>
                  <td>
                    <p-calendar
                      [(ngModel)]="titulo.vencimento"
                      dateFormat="dd/mm/yy"
                      [showIcon]="true"
                      [placeholder]="dataAtualFormatada"
                      [appendTo]="'body'"
                      panelStyleClass="dropdown-panel-above-modal"
                      class="prazo-calendar"
                      (onSelect)="atualizarDatasVencimento(i)">
                    </p-calendar>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Totais Prazo -->
      <div class="totais-section">
        <div>
          <span>{{ 'forma_pagamento.total_enviado' | translate }}</span>
          <strong *ngIf="moedaPadrao === 'PYG'" [ngStyle]="{ color: corTotalEnviado }">
            {{ calcularTotalEnviado() | guaraniFormat }}
          </strong>
          <strong *ngIf="moedaPadrao !== 'PYG'" [ngStyle]="{ color: corTotalEnviado }">
            {{ calcularTotalEnviado() | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
          </strong>
        </div>
        <div>
          <span>{{ 'forma_pagamento.total_a_pagar' | translate }}</span>
          <strong *ngIf="moedaPadrao === 'PYG'">{{ totalAPagar | guaraniFormat }}</strong>
          <strong *ngIf="moedaPadrao !== 'PYG'">{{ totalAPagar | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</strong>
        </div>
      </div>
    </div>

    <!-- ===== CARTAO ===== -->
    <div *ngIf="formaPagamentoSelecionada === 'cartao'" class="conta-section">
      <div class="conta-card">
        <div class="conta-card-header">
          <div class="conta-card-icon">
            <i class="pi pi-credit-card"></i>
          </div>
          <div class="conta-card-info">
            <span class="conta-card-title">{{ 'forma_pagamento.cartao' | translate }}</span>
            <span class="conta-card-subtitle">{{ 'forma_pagamento.cartao_subtitulo' | translate }}</span>
          </div>
        </div>
        <div class="conta-card-body">
          <div class="conta-field">
            <label>{{ 'forma_pagamento.conta' | translate }}</label>
            <p-dropdown
              [options]="contasTarjetaQrcodeFiltradas"
              [(ngModel)]="cartaoContaSelecionada"
              optionLabel="label"
              [placeholder]="'forma_pagamento.selecione_conta' | translate"
              [filter]="true"
              filterBy="label"
              [showClear]="true"
              [appendTo]="'body'"
              panelStyleClass="dropdown-panel-above-modal"
              [style]="{ width: '100%' }">
              <ng-template pTemplate="selectedItem" let-conta>
                <div class="dropdown-conta-item" *ngIf="conta">
                  <img *ngIf="getFlagUrlFromConta(conta)" [src]="getFlagUrlFromConta(conta)" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-conta>
                <div class="dropdown-conta-item">
                  <img *ngIf="getFlagUrlFromConta(conta)" [src]="getFlagUrlFromConta(conta)" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>

          <div class="conta-field" *ngIf="contasTarjetaQrcodeFiltradas.length === 0">
            <small class="fp-aviso">{{ 'forma_pagamento.nenhuma_conta_tarjeta_qrcode' | translate }}</small>
          </div>


          <!--
            Mesmo `informacaoDaTransacao` do painel de Transferencia: a troca de aba passa pelo
            `resetarCamposPagamento()`, entao o texto de uma forma nunca vaza para a outra.
          -->
          <div class="conta-field">
            <label for="cartaoInfoTransacao">{{ 'forma_pagamento.informacao_transacao' | translate }}</label>
            <textarea
              id="cartaoInfoTransacao"
              pInputTextarea
              autoResize="true"
              rows="3"
              [(ngModel)]="informacaoDaTransacao"
              [placeholder]="'forma_pagamento.informacao_transacao_placeholder' | translate"
              style="width: 100%;"></textarea>
          </div>
        </div>
      </div>

      <!-- Totais Cartao -->
      <div class="totais-section">
        <div>
          <span>{{ 'forma_pagamento.total_a_pagar' | translate }}</span>
          <strong *ngIf="moedaPadrao === 'PYG'">{{ totalAPagar | guaraniFormat }}</strong>
          <strong *ngIf="moedaPadrao !== 'PYG'">{{ totalAPagar | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</strong>
        </div>
      </div>
    </div>

    <!-- ===== QR CODE ===== -->
    <div *ngIf="formaPagamentoSelecionada === 'qrcode'" class="conta-section">
      <div class="conta-card">
        <div class="conta-card-header">
          <div class="conta-card-icon">
            <i class="pi pi-qrcode"></i>
          </div>
          <div class="conta-card-info">
            <span class="conta-card-title">{{ 'forma_pagamento.qrcode' | translate }}</span>
            <span class="conta-card-subtitle">{{ 'forma_pagamento.qrcode_subtitulo' | translate }}</span>
          </div>
        </div>
        <div class="conta-card-body">
          <!-- A conta do QR nao e escolhida aqui: vem de Dados de recebimento, junto das chaves
               da Bancard. Sem ela nao ha onde lancar o recebimento, e a venda por QR fica
               bloqueada ate o lojista cadastrar a conta e vincula-la. -->
          <div class="conta-field" *ngIf="contaQrCode">
            <label>{{ 'forma_pagamento.conta' | translate }}</label>
            <input type="text" pInputText [value]="contaQrCode.label" readonly style="width: 100%;" />
            <small class="fp-ajuda">{{ 'forma_pagamento.qrcode_conta_fixa' | translate }}</small>
          </div>

          <div class="conta-field" *ngIf="!contaQrCode">
            <small class="fp-aviso">{{ 'forma_pagamento.qrcode_sem_conta_configurada' | translate }}</small>
          </div>

          <!-- Sem dados de recebimento configurados nao ha como gerar o QR:
               resta registrar manualmente um recebimento feito por fora. -->
          <div class="conta-field" *ngIf="!bancardConfigurado && contaQrCode">
            <small class="fp-aviso">
              {{ 'forma_pagamento.qrcode_sem_configuracao' | translate }}
            </small>
            <label>{{ 'forma_pagamento.qrcode_codigo_transacao' | translate }}</label>
            <input
              type="text"
              pInputText
              [(ngModel)]="qrcodeCodigoTransacao"
              [placeholder]="'forma_pagamento.qrcode_codigo_placeholder' | translate"
              style="width: 100%;" />
          </div>

          <div class="conta-field" *ngIf="bancardConfigurado && contaQrCode">
            <button
              *ngIf="!qrCodeEmAndamento"
              pButton
              type="button"
              icon="pi pi-qrcode"
              [label]="'forma_pagamento.qrcode_gerar' | translate"
              [disabled]="estadoQrCode.gerando || !contaQrCode"
              [loading]="estadoQrCode.gerando"
              (click)="gerarQrCode.emit()"
              style="width: 100%;">
            </button>

            <!-- #blocoQrCode: alvo do scroll automatico — assim que o codigo aparece a tela
                 rola ate ele, para o operador nao ter de procurar dentro do dialog. -->
            <div *ngIf="qrCodeEmAndamento" class="fp-qrcode" #blocoQrCode>
              <img
                *ngIf="estadoQrCode.urlQr"
                class="fp-qrcode__imagem"
                [src]="estadoQrCode.urlQr"
                [alt]="'forma_pagamento.qrcode' | translate" />

              <div *ngIf="!estadoQrCode.confirmado" class="fp-qrcode__status">
                <span class="fp-qrcode__titulo">
                  <i class="pi pi-spin pi-spinner"></i>
                  {{ 'forma_pagamento.qrcode_aguardando_titulo' | translate }}
                </span>
                <span class="fp-qrcode__instrucao">
                  {{ 'forma_pagamento.qrcode_aguardando_detalhe' | translate }}
                </span>
              </div>

              <p *ngIf="estadoQrCode.confirmado" class="fp-qrcode__confirmado">
                <i class="pi pi-check-circle"></i>
                {{ 'forma_pagamento.qrcode_confirmado' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Totais QR Code -->
      <div class="totais-section">
        <div>
          <span>{{ 'forma_pagamento.total_a_pagar' | translate }}</span>
          <strong *ngIf="moedaPadrao === 'PYG'">{{ totalAPagar | guaraniFormat }}</strong>
          <strong *ngIf="moedaPadrao !== 'PYG'">{{ totalAPagar | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</strong>
        </div>
      </div>
    </div>

  </div><!-- fim dialog-wave-body -->

  <ng-template pTemplate="footer">
    <button pButton
      class="p-button-secondary"
      (click)="fecharDialog()"
      [disabled]="processando">
      {{ 'forma_pagamento.cancelar' | translate }} (Esc)
    </button>
    <button pButton
      [disabled]="processando || !pagamentoDinheiroValido || !pagamentoContaValido || !pagamentoPrazoValido || !pagamentoQrCodeValido"
      [icon]="processando ? 'pi pi-spin pi-spinner' : (config.iconeBotaoConfirmar || 'pi pi-check')"
      (click)="onConfirmar()">
      {{ processando ? '' : (config.labelBotaoConfirmar || ('forma_pagamento.confirmar' | translate)) }}
      (Ctrl+Enter)
    </button>
  </ng-template>
</p-dialog>

<!--
  Templates de cards de moeda foram extraidos para
  `app-forma-pagamento-cards` (DRY — spec 06).
  Ver `shared/components/forma-pagamento-cards/forma-pagamento-cards.component.html`.
-->

